'use client';

import React from 'react';
import classNames from 'classnames';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

// Types
import { ButtonProps } from '../../types/actions/buttons';

// Services
import { validate } from '../../services/actions/button';

// Components
import { Icon } from '../Display/Icon';
import { Tooltip } from '../Display/Tooltip';

export const Button = (props: ButtonProps) => {
  validate(props);

  const {
    id,
    ref,
    type,
    icon,
    size,
    onClick,
    variant,
    addBlock,
    addGhost,
    disabled,
    children,
    alignment,
    className,
  } = props;

  return (
    <Tooltip
      id={id}
      tooltip={typeof children === 'string' ? children : undefined}
    >
      <button
        ref={ref}
        data-size={size}
        onClick={onClick}
        disabled={disabled}
        data-type={variant}
        type={type ?? 'submit'}
        data-display={addBlock ? 'block' : undefined}
        className={classNames('button', {
          ghost: addGhost,
          [`${alignment}`]: alignment,
          [`${className}`]: className,
        })}
      >
        {variant === 'negative' && (
          <>
            <Icon icon={faExclamationTriangle} />
            <span>{children}</span>
          </>
        )}

        {variant !== 'negative' && (
          <>
            {!icon && <span>{children}</span>}

            {icon && variant === 'icon-button' && (
              <>
                <Icon icon={icon.definition} />
                <span className="sr-only">{children}</span>
              </>
            )}

            {icon && variant !== 'icon-button' && variant !== 'icon' && (
              <>
                {icon?.position === 'left' && <Icon icon={icon.definition} />}

                <span>{children}</span>

                {icon && icon?.position === 'right' && (
                  <Icon icon={icon.definition} />
                )}
              </>
            )}

            {icon && variant === 'icon' && (
              <>
                <Icon icon={icon.definition} />
                <span className="sr-only">{children}</span>
              </>
            )}
          </>
        )}
      </button>
    </Tooltip>
  );
};
